import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import _isFinite from 'lodash/isFinite';
import _pick from 'lodash/pick';
import { chatActions, chatSelectors, contactSelectors } from '@lifesize/nucleus';
import { bookmarkScrollPosition, messageReceived } from 'actions/Chat';
import ChatWindow from 'components/Chat/ChatWindow';
import { currentConversationDialStringSelector } from 'selectors/chat';

function mapDispatchToProps(dispatch) {
  return {
    onBookmarkScroll: ({ conversationId, lastMessageId, scrollPosition }) => {
      if (conversationId && _isFinite(scrollPosition)) {
        dispatch(bookmarkScrollPosition(conversationId, { lastMessageId, scrollPosition }));
      }
    },
    onGetMoreMessages: (conversation, messageCount = 25) => {
      const contact = _get(conversation, 'contact', undefined);
      if (contact) {
        dispatch(chatActions.getMoreMessagesForConversation(contact, messageCount));
      }
    },
    resetChatFlag: () => {
      dispatch(messageReceived());
    }
  };
}

function mapStateToProps(state) {
  const conversationContactDialString = currentConversationDialStringSelector(state);
  const conversationMode = _get(state, 'app.chat.conversationMode');
  const conversations = chatSelectors.groupedConversations(state);
  const meetingConversations = conversations.meetingConversations || [];
  const userConversations = conversations.userConversations || [];
  const currentConversation = chatSelectors.getChatForWebGenerator(state)(conversationContactDialString);
  const isFirstUse = !meetingConversations.length && !userConversations.length;
  const hasNewChat = _get(state, 'app.chat.hasNewChat');

  const contactGenerator = contactSelectors.getContactByUuidGenerator(state);
  const participants = (_get(currentConversation, 'participants') || []).map((participant) => {
    return {
      ...participant,
      ..._pick(contactGenerator(participant.uuid), ['isOnline', 'isMeeting', 'meetingType'])
    };
  });

  return {
    conversation: currentConversation,
    conversationContactDialString,
    hasNewChat,
    isChatLoading: _get(state, 'app.chat.isLoading'),
    isFirstUse,
    isGettingMessages: _get(state, 'app.chat.isGettingMessages'),
    mode: conversationMode,
    participants,
    scrollBookmarks: _get(state, 'app.chat.scrollBookmarks')
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ChatWindow));
